<template>
  <div>
    <HeaderBreadcrumbs :items="[
      { label: 'Books', to: '/ebooks' }
    ]" title="All Books" />
    <div class="flex-col w-full bg-white shadow-sm rounded-lg">
      <div class=" w-full  flex items-center justify-between rounded-lg px-4 mt-3 mb-2 py-0 pt-3">
        <div class="w-2/6 relative">
          <i class="fa-solid fa-magnifying-glass text-gray-400 text-base absolute top-3 left-3"></i>
          <input placeholder="Search File Name or ID" class="p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg"
            type="search" v-model="query_search" @input="onSearch" v-on:keyup.enter="onSearch" />
        </div>
        <div class="relative w-3/4 flex justify-end">
          <Button
            variant="default"
            size="sm"
            class="mr-2"
            color="primary"
            >
            <router-link class="text-white px-0 py-2 hover:no-underline" :to="{ name: ManageFormEbookPath.name }">
              <i class="fa fa-plus"></i> Add New
            </router-link>
          </Button>
            <Button 
          @click="popupBulkBook"
          variant="outlined"
          size="sm"
          class="mx-2"
          color="alternative"
            >  Bulk Action
          </Button>
          <Button 
          @click="toggleDropdown"
          variant="outlined"
          size="sm"
          class="ml-2"
          color="alternative"
            > <i class="fa-solid fa-filter"></i> Filter <i class="fa-solid fa-chevron-down"></i>
          </Button>
          <FilterComponent :isDropdownVisible.sync="isDropdownVisible" :statusProp="this.status"
            :vendorProp="this.vendor" @reloadPage="reloadPage" @input="handleFilterInput" />


        </div>
      </div>
      <div>
        <div class="flex justify-start items-center px-3 mb-3">
          <div class="mr-2">
              <Label variant="gray" class="bg-white text-sm px-0">
              Show
            </Label>
          </div>
          <div class="mr-4">
            <Label variant="gray" class="bg-white"  :class="{ 'opacity-50': isLoading }">
              <input 
              type="radio" 
              :disabled="isLoading"
              :class="{ 'opacity-50': isLoading }"
              checked 
              value="all" 
              class="mr-1"
              v-model="filterByStatusRadio" 
              name="statusFilter"
              @change="filterByStatus('all')" 
              />
              All
            </Label>
          </div>
          <div class="mr-4">
            <Label variant="gray" class="bg-white" :class="{ 'opacity-50': isLoading }">
              <input 
              class="mr-1"
               :disabled="isLoading"
              type="radio" 
              :class="{ 'opacity-50': isLoading }"
              v-model="filterByStatusRadio" 
              name="statusFilter" 
              value="ready for upload"
              @change="filterByStatus('ready for upload')" 
              />
              Ready For Upload
            </Label>
          </div>

          <div class="mr-4">
            <Label variant="gray" class="bg-white"  :class="{ 'opacity-50': isLoading }">
              <input 
              class="mr-1"
               :disabled="isLoading"
              type="radio" 
              :class="{ 'opacity-50': isLoading }"
              v-model="filterByStatusRadio" 
              name="statusFilter" 
              value="failed to upload"
              @change="filterByStatus('failed to upload')" />
              Failed to Upload
            </Label>
          </div>
          <div>
            <Label variant="gray" class="bg-white" :class="{ 'opacity-50': isLoading }">
              <input 
              class="mr-1"
              type="radio" 
              :class="{ 'opacity-50': isLoading }"
               :disabled="isLoading"
              v-model="filterByStatusRadio" 
              name="statusFilter" 
              value="need approval"
              @change="filterByStatus('need approval')" />
            Need Approval
            </Label>
          </div>
        </div>

        <TableBooks class="border-b border-gray-50 " id="my-table" :books="ebooks" :currentPage="currentPage"
          :perPage="perPage" :isLoading="isLoading" :reloadPage="reloadPage" @sort-by="handleSortBy" />
      </div>
      <div v-if="ebooks.length"
        class="flex bg-white justify-between pl-5 pr-3 pt-4 mb-5 border-t border-gray-100 mt-1">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{ currentPage }}-{{ perPage }} <span
            class="text-gray-500 font-normal">of</span> {{ formatPriceBasic(totalRows) }}
        </div>
        <div class="mb-2">
          <t-pagination :total-items="Number(totalRows)" :per-page="perPage" v-model="currentPage"
            @change="onClickPage" />
        </div>
      </div>
        <t-modal ref="openBulk">
      <div class="text-sm flex-col text-left">
        <label class="text-left text-lg font-semibold">Bulk Action</label>
         <template>
  <div class="space-y-6">

    <!-- Metadata -->
    <div
      class="flex items-center  p-2.5 justify-start rounded-2xl border-2 cursor-pointer"
      :class="selectedBulk === 'metadata'
        ? 'border-gray-200 bg-gray-50'
        : 'border-gray-200'"
      @click="selectOption('metadata')"
    >
      <div class="w-5 h-5 mr-2 rounded-full border-2 flex items-center justify-center"
        :class="selectedBulk === 'metadata' ? 'border-gray-200' : 'border-gray-300'">
        <div v-if="selectedBulk === 'metadata'" class="w-3 h-3 rounded-full bg-blue-500"></div>
      </div>

      <div>
        <h3 class="text-base mb-0 font-semibold text-gray-900">
          Bulk Import Metadata
        </h3>
        <p class="text-gray-500 text-xs mt-0 mb-1">
          Using .CSV file to create meta data details.
        </p>
      </div>
    </div>

    <!-- Upload -->
    <div
      class="flex items-center p-2.5 justify-start rounded-2xl border cursor-pointer"
      :class="selectedBulk === 'upload'
        ? 'border-gray-200 bg-gray-50'
        : 'border-gray-200'"
      @click="selectOption('upload')"
    >
      <div class="w-5 h-5 mr-2 rounded-full border flex items-center justify-center"
        :class="selectedBulk === 'upload' ? 'border-gray-200' : 'border-gray-200'">
        <div v-if="selectedBulk === 'upload'" class="w-3 h-3 rounded-full bg-blue-500"></div>
      </div>

      <div>
        <h3 class="text-base mb-0 font-semibold text-gray-900">
         Bulk Upload File Books
        </h3>
        <p class="text-gray-500 text-xs mt-0 mb-1">
       Import content PDF/EPUB books simultaneously.
        </p>
      </div>
    </div>

  </div>
</template>

      </div>
      <div class="flex justify-left mt-3 space-x-3">
          <Button @click="nextUpload"  class="flex justify-items-start items-center"  variant="default" color="primary" size="xs">
            Next
          </Button>  
     <Button @click="cancelpopup"  class="flex justify-items-start items-center"  variant="outlined" color="alternative" size="xs">   
      Cancel
    </Button>
      </div>
    </t-modal>
    </div>
  </div>

</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import TableBooks from '../../components/ebook/table.vue';
import FilterComponent from '../../components/form/FilterComponent.vue'
import { EventBus } from '../../event-bus';
import 'flowbite';
import 'flowbite/dist/flowbite.css';
import { ManageFormEbookPath } from '../../router/content';
import constant from '../../store/constant';
//import SortComponent from '../../components/form/SortComponent.vue'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Button from '@/components/ui/Button';
import Label from '@/components/ui/Label.vue';

const ITEM_STATUS = Object.entries(constant.ITEM_STATUS).map((item) => {
  return { text: item[0], value: item[1] };
});
const ITEM_CONTENT_TYPE = Object.entries(constant.ITEM_CONTENT_TYPE).map((item) => {
  return { text: item[0], value: item[1] };
});

const { ROLES } = constant;
export default {
  name: 'ebooks',
  components: {
    TableBooks,
    FilterComponent,
    HeaderBreadcrumbs,
    Button,
    Label
    //  SortComponent
  },
  data() {
    return {
      ManageFormEbookPath,
      query_search: null,
      currentPage: 1,
      perPage: 15,
      selectedBulk:'metadata',
      filterStatus: [],
      filterByStatusRadio: 'all',
      sortOrder: [],
      vendor: [],
      vendorSearchOptions: [],
      isVendorSearch: false,
      status: [],
      isDropdownVisible: false,
      contentType: null,
      createdSort: null,
      statusOptions: [
        { text: '---Status [All]---', value: null },
        ...ITEM_STATUS,
      ],
      contentTypeOptions: [
        { text: '---Content Type [All]---', value: null },
        ...ITEM_CONTENT_TYPE,
      ],
      debounce: null,
      roleID: JSON.parse(localStorage.getItem("session_auth")).role_id,
      typing: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title =
          to.meta.title ||
          'Ebook | Content Management System Ebooks Gramedia.com';
      },
    },
    success: function () {
      // if(this.success){
      //   EventBus.$emit('show-toast', {
      //     message:this.message,
      //     type: 'success',
      //     });
      //     setTimeout(() => {
      //       this.$router.push({ path: "/" });
      //     }, 1500);
      // }
    },
    isError: function () {
      if (this.isError) {
        EventBus.$emit('show-toast', {
          message: ' Opps .. Something is wrong',
          type: 'success',
        });
      }
    }
  },
  computed: {
    ...mapGetters('auth', { auth: 'auth' }),
    ...mapGetters('ebooks', ['ebooks']),
    ...mapState({
      isLoading: (state) => state.ebooks.isLoading,
      isError: (state) => state.ebooks.isError,
      ebooks: (state) => state.ebooks.items,
      totalRows: (state) => state.ebooks.totalRows,
    }),
    isModalVisibleDelete() {
      return this.showModalDelete
    }
  },
  created() {
    this.actionFirst();
  },
  methods: {
    ...mapActions('vendors', ['searchVendors']),
    ...mapActions('ebooks', ['fetchEbooks', 'searchBooks']),

    actionFirst() {
      const query = this.$route.query;
      this.currentPage = query.page ?? this.currentPage;
      this.perPage = query.limit ?? this.perPage;
      this.query_search = query.q ?? this.query_search;
      this.status = query.status ?? this.status;
      if (typeof (query.vendor_id) == "string") {
        const vendor = query.vendor_id.split("#");
        this.vendor = [{ id: vendor[0], name: vendor[1] }];
      } else {
        this.vendor = (query.vendor_id ?? []).map(val => {
          const vendor = val.split("#");
          return {
            id: vendor[0],
            name: vendor[1],
          }
        });
      }
      this.reloadPage();
    },
    actionGetEbooks() {
      this.vendor = [];
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
        statuses: [],
      };
      this.fetchEbooks(payload);
      this.setQuery(payload);
    },
    selectOption(type){
      this.selectedBulk = type
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    setContentType(getContentType) {
      this.contentType = getContentType;
      this.reloadPage();
    },
    handleFilterInput({ contentType, status, vendor }) {
      this.contentType = contentType;
      this.status = status;
      this.vendor = vendor;
      this.filterStatus = [];
      this.currentPage = 1
      this.filterByStatusRadio = 'all';
    },
    handleResetFromChild() {
      this.status = [];
      this.filterStatus = [];
      this.filterByStatusRadio = 'all';
      this.vendor = [];
      this.contentType = null;
      this.createdSort = null;

      this.reloadPage();
    },
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    onSearch(event) {
      this.query_search = event.target.value;
      this.currentPage = 1;
      if (!this.query_search && !this.vendor.length) {
        this.actionGetEbooks();
        clearTimeout(this.debounce);
        return;
      }
      this.typing = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = false;
        this.actionSearchEbooks();
      }, 600);
    },
    onClearSearch() {
      this.query_search = null;
      this.vendor = [];
      this.status = null;
      this.currentPage = 1;
      this.contentType = null;
      this.contentTypeOptions = []
      this.createdSort = null;
      this.reloadPage();
    },
    popupBulkBook() {
  this.$refs.openBulk.show();
    },
   nextUpload() {
  if (this.selectedBulk === 'upload') {
    this.$router.push('/items/bulk/upload/books')
  }
   if (this.selectedBulk === 'metadata') {
    this.$router.push('/items/bulk-csv/upload/books')
  }
},
    cancelpopup() {
 this.$refs.openBulk.hide();
    },
    onClickPage(page) {
      this.currentPage = page;
      this.reloadPage();
    },
    actionSearchEbooks() {
      const payload = {
        q: this.query_search ?? '',
        page: this.currentPage,
        limit: this.perPage,
        vendor_id: this.vendor.map((val) => val.id),
        statuses: [], // default kosong
        content_type: this.contentType,
        sort: this.sortOrder.criteria,
        order: this.sortOrder.order
      };

      if (this.status && this.status.length > 0) {
        payload.statuses = this.status;
      } else if (this.filterStatus && this.filterStatus.length > 0) {
        payload.statuses = this.filterStatus;
      } else {
        payload.statuses = [];
      }


      this.searchBooks(payload);
      payload.vendor_id = this.vendor.map((val) => `${val.id}#${val.name}`);
      this.setQuery(payload);
    },
    toggleList() {
      this.showList = !this.showList;
    },
    async filterByStatus(status) {

      this.status = [];
      this.filterStatus = [];
      this.vendor = []
      this.filterByStatusRadio = status;
      this.currentPage = 1
      if (status === 'all') {
        await this.actionGetEbooks();
        return;
      }
      this.filterStatus = ITEM_STATUS
        .filter(item => item.value === status)
        .map(item => item.value);

      await this.actionSearchEbooks();
    },
    vendorFind(query) {
      if (!query) return;

      this.isVendorSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          name: query,
          limit: 10,
        };
        this.searchVendors(payload)
          .then((response) => {
            this.vendorSearchOptions = response.data.data.rows;
            this.isVendorSearch = false;
          })
          .catch(() => {
            this.isVendorSearch = false;
          });
      }, 600);
    },
    reloadPage() {
      const hasStatus =
        (this.status && this.status.length > 0) ||
        (this.filterStatus && this.filterStatus.length > 0);

      const hasAnyFilter =
        !!this.query_search ||
        this.vendor.length > 0 ||
        !!this.contentType ||
        !!this.createdSort ||
        hasStatus;

      if (!hasAnyFilter) {
        this.actionGetEbooks();
      } else {
        this.actionSearchEbooks();
      }
    },
    vendorChange() {
      this.currentPage = 1;
      this.reloadPage();
    },
    vendorRemove() {
      this.vendor = [];
      if (this.query_search) this.actionSearchEbooks();
      else this.actionGetEbooks();
    },
    statusChange() {
      this.reloadPage();
    },
    changeContentType() {
      this.reloadPage();
    },
    handleSortBy(criteria) {
      this.sortOrder = criteria
      this.actionSearchEbooks();
    },
    permFilterVendor() {
      switch (this.auth.role_id) {
        case ROLES.SUPER_ADMIN:
          return true;
        case ROLES.INTERNAL_ADMIN:
          return true;
        case ROLES.INTERNAL_DATA_ENTRY:
          return true;
        default:
          return false;
      }
    },
    setQuery(q = {}) {
      this.$router.push({ path: this.$route.path, state: q }).catch(() => { });
    }
  },
};
</script>

<style scoped></style>
